(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gt-hoodie-shop"] && !Shopify.designMode) return;
  try {
    
  class GtHoodieShop extends HTMLElement {
    connectedCallback() {
      this.map = JSON.parse(this.querySelector('[data-shop-map]').textContent);
      this.codes = { Small: 'S', Medium: 'M', Large: 'L', 'X-Large': 'XL' };
      this.form = this.querySelector('[data-cart-form]');
      this.note = this.querySelector('[data-note]');

      this.colour = this.map.order[0];
      this.size = this.firstAvailableSize(this.colour);
      this.partner = this.otherColours()[0];
      this.partnerSize = this.size;
      this.partnerSizeTouched = false;

      this.renderSizes();
      this.renderPartnerChips();
      this.deliveryEstimate();

      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('keydown', (e) => this.onKeydown(e));
      this.addEventListener('change', (e) => {
        if (e.target.name === 'gt-hs-tier') this.sync();
      });
      this.form.addEventListener('submit', (e) => this.onSubmit(e));

      this.sync();
    }

    get tier() {
      return Number(this.querySelector('input[name="gt-hs-tier"]:checked')?.value || 1);
    }
    colourData(name) { return this.map.colours[name]; }
    otherColours() { return this.map.order.filter((c) => c !== this.colour); }
    sizeNames() { return Object.keys(this.colourData(this.colour).sizes); }

    firstAvailableSize(colour) {
      const sizes = this.map.colours[colour].sizes;
      return Object.keys(sizes).find((s) => sizes[s].available) || Object.keys(sizes)[0];
    }

    onClick(e) {
      const sw = e.target.closest('[data-colour]');
      if (sw) { e.preventDefault(); this.setColour(sw.dataset.colour); return; }
      const sz = e.target.closest('[data-size]');
      if (sz && !sz.disabled) {
        e.preventDefault();
        this.size = sz.dataset.size;
        if (!this.partnerSizeTouched) this.partnerSize = this.size;
        this.renderSizes();
        this.renderPartnerChips();
        this.sync();
        return;
      }
      const pc = e.target.closest('[data-partner]');
      if (pc) { e.preventDefault(); this.partner = pc.dataset.partner; this.renderPartnerChips(); this.sync(); return; }
      const ps = e.target.closest('[data-partner-size]');
      if (ps) {
        e.preventDefault();
        this.partnerSize = ps.dataset.partnerSize;
        this.partnerSizeTouched = true;
        this.renderPartnerChips();
        this.sync();
      }
    }

    // Radio groups are expected to move selection with the arrow keys; without
    // this the role="radiogroup" is a promise the markup does not keep.
    onKeydown(e) {
      const group = e.target.closest('[role="radiogroup"]');
      if (!group || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(e.key)) return;
      const items = [...group.querySelectorAll('[role="radio"]:not([disabled])')];
      const i = items.indexOf(e.target);
      if (i < 0) return;
      e.preventDefault();
      const last = items.length - 1;
      let next = i;
      if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
      if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
      if (e.key === 'Home') next = 0;
      if (e.key === 'End') next = last;
      items[next].click();
      items[next].focus();
    }

    setColour(name) {
      if (!this.map.colours[name]) return;
      this.colour = name;
      this.querySelectorAll('[data-colour]').forEach((b) => {
        const on = b.dataset.colour === name;
        b.setAttribute('aria-checked', String(on));
        b.tabIndex = on ? 0 : -1;
      });
      this.querySelectorAll('[data-gallery]').forEach((g) => { g.hidden = g.dataset.gallery !== name; });
      this.querySelector('[data-colour-label]').textContent = name;
      // keep the chosen size if the new colour has it, else fall back
      const sizes = this.colourData(name).sizes;
      if (!sizes[this.size] || !sizes[this.size].available) this.size = this.firstAvailableSize(name);
      if (!this.partnerSizeTouched) this.partnerSize = this.size;
      if (this.partner === name) this.partner = this.otherColours()[0];
      this.renderSizes();
      this.renderPartnerChips();
      this.sync();
    }

    renderSizes() {
      const sizes = this.colourData(this.colour).sizes;
      const row = this.querySelector('[data-sizes]');
      row.innerHTML = this.sizeNames().map((s) => {
        const v = sizes[s];
        const on = s === this.size;
        return `<button type="button" class="gt-hs__chip" data-size="${s}" role="radio"` +
          ` aria-checked="${on}" tabindex="${on ? 0 : -1}"${v.available ? '' : ' disabled'}>` +
          `${this.codes[s] || s}</button>`;
      }).join('');
      this.querySelector('[data-size-label]').textContent = this.size || '';
    }

    renderPartnerChips() {
      const cRow = this.querySelector('[data-partner-colours]');
      const sRow = this.querySelector('[data-partner-sizes]');
      if (!cRow || !sRow) return;
      const others = [...this.otherColours(), this.colour];
      cRow.innerHTML = others.map((c) => {
        const label = c === this.colour ? `${c} &times;2` : c;
        return `<button type="button" class="gt-hs__chip" data-partner="${c}"` +
          ` aria-pressed="${c === this.partner}">${label}</button>`;
      }).join('');
      sRow.innerHTML = this.sizeNames().map((s) =>
        `<button type="button" class="gt-hs__chip" data-partner-size="${s}"` +
        ` aria-pressed="${s === this.partnerSize}">${this.codes[s] || s}</button>`).join('');
    }

    variantId() {
      if (this.tier === 1) return this.colourData(this.colour).sizes[this.size]?.id || null;
      if (this.tier === 3) return this.map.trois[this.codes[this.size] || this.size] || null;
      const a = `${this.colour} · ${this.codes[this.size] || this.size}`;
      const b = `${this.partner} · ${this.codes[this.partnerSize] || this.partnerSize}`;
      return this.map.deux[`${a}|${b}`] || null;
    }

    sync() {
      const c = this.colourData(this.colour);
      const pick = this.querySelector('[data-pick]');
      if (pick) pick.hidden = this.tier !== 2;

      // price + savings follow the tier, not just the colour
      const priceEl = this.querySelector('[data-price]');
      const cmpEl = this.querySelector('[data-compare]');
      const pillEl = this.querySelector('[data-save-pill]');
      let price = c.price, compare = c.compare;
      if (this.tier === 2) { price = this.map.deuxPrice; compare = c.price * 2; }
      if (this.tier === 3) { price = this.map.troisPrice; compare = c.price * 3; }
      priceEl.textContent = this.money(price);
      if (cmpEl) { cmpEl.textContent = this.money(compare); cmpEl.hidden = !(compare > price); }
      if (pillEl) {
        const pct = compare > price ? Math.round(((compare - price) / compare) * 100) : 0;
        pillEl.textContent = `Save ${pct}%`;
        pillEl.hidden = pct <= 0;
      }

      const s2 = this.querySelector('[data-save="2"]');
      if (s2) s2.textContent = `Save ${this.moneyShort(c.price * 2 - this.map.deuxPrice)}`;
      const s3 = this.querySelector('[data-save="3"]');
      if (s3) s3.textContent = `All three colours · Save ${this.moneyShort(c.price * 3 - this.map.troisPrice)}`;

      this.renderRating(c);
      this.renderStock(c);

      const id = this.variantId();
      const input = this.querySelector('[data-variant-input]');
      const btn = this.querySelector('[data-atc]');
      if (id) {
        input.value = String(id);
        btn.disabled = false;
        this.note.hidden = this.tier === 1;
        if (this.tier === 2) {
          this.note.textContent =
            `${this.colour} ${this.codes[this.size]} + ${this.partner} ${this.codes[this.partnerSize]} · ${this.map.deuxPriceText} total.`;
        } else if (this.tier === 3) {
          this.note.textContent = `${this.map.order.join(' + ')} · ${this.codes[this.size]} · ${this.map.troisPriceText} total.`;
        }
      } else {
        btn.disabled = true;
        this.note.hidden = false;
        this.note.textContent = this.tier === 1
          ? 'That size is sold out — pick another.'
          : 'That combination is sold out — pick another colour or size.';
      }
    }

    renderRating(c) {
      const wrap = this.querySelector('[data-rating]');
      if (!c.rating || !c.reviewCount) { wrap.hidden = true; return; }
      wrap.hidden = false;
      const r = Math.round(c.rating * 10) / 10;
      this.querySelector('[data-stars-fill]').style.inlineSize = `${(r / 5) * 100}%`;
      this.querySelector('[data-rating-text]').textContent = `${r.toFixed(1)} · ${c.reviewCount} reviews`;
      wrap.querySelector('.gt-hs__stars').setAttribute('role', 'img');
      wrap.querySelector('.gt-hs__stars').setAttribute('aria-label', `${r.toFixed(1)} out of 5 from ${c.reviewCount} reviews`);
    }

    // Mirrors the PDP rule: a stock line appears only when the real count is
    // at or below the threshold. It never invents a number.
    renderStock(c) {
      const el = this.querySelector('[data-stock]');
      const threshold = parseInt(this.dataset.lowStock, 10) || 0;
      const v = c.sizes[this.size];
      if (this.tier !== 1 || !v || v.tracked !== 'shopify' || v.qty <= 0 || v.qty > threshold) {
        el.hidden = true; return;
      }
      el.hidden = false;
      el.textContent = `Only ${v.qty} left in ${this.size}.`;
    }

    // Match the store's own money format exactly ($49.00) so the JS-updated
    // price never disagrees with a Liquid-rendered one a few pixels away.
    money(cents) { return `$${(cents / 100).toFixed(2)}`; }

    // Savings read better without trailing zeros, mirroring the PDP's
    // money_without_trailing_zeros.
    moneyShort(cents) {
      const n = cents / 100;
      return `$${n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)}`;
    }

    deliveryEstimate() {
      const n = (k) => parseInt(this.dataset[k], 10) || 0;
      const el = this.querySelector('[data-delivery]');
      if (!el) return;
      const lo = this.addBusinessDays(n('dispatchMin') + n('transitMin'));
      const hi = this.addBusinessDays(n('dispatchMax') + n('transitMax'));
      const fmt = (d) => d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
      el.innerHTML = `Order today, arrives <strong>${fmt(lo)}&nbsp;&ndash;&nbsp;${fmt(hi)}</strong>`;
    }

    addBusinessDays(days) {
      const d = new Date();
      let left = days;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        const day = d.getDay();
        if (day !== 0 && day !== 6) left -= 1;
      }
      return d;
    }

    async onSubmit(e) {
      const id = this.variantId();
      if (!id) { e.preventDefault(); return; }
      // Let the plain POST through if fetch is unavailable for any reason.
      if (!window.fetch) return;
      e.preventDefault();
      const btn = this.querySelector('[data-atc]');
      const label = this.querySelector('[data-atc-text]');
      const original = label.textContent;
      btn.disabled = true;
      label.textContent = 'Adding…';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
        });
        if (!res.ok) throw new Error(await res.text());
        window.location.href = this.dataset.afterAdd === 'checkout' ? '/checkout' : '/cart';
      } catch (err) {
        btn.disabled = false;
        label.textContent = original;
        this.note.hidden = false;
        this.note.textContent = 'Could not add that to the cart. Please try again.';
      }
    }
  }
  if (!customElements.get('gt-hoodie-shop')) customElements.define('gt-hoodie-shop', GtHoodieShop);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wraps = document.querySelectorAll('[data-carousel]');

    const setup = (wrap) => {
      const scroller = wrap.querySelector('[data-scroller]');
      const prev = wrap.querySelector('[data-scroll-prev]');
      const next = wrap.querySelector('[data-scroll-next]');
      if (!scroller) return;

      const fits = () => scroller.scrollWidth <= scroller.clientWidth + 2;

      const refresh = () => {
        const fitNow = fits();
        wrap.toggleAttribute('data-fits', fitNow);
        if (prev) prev.disabled = fitNow || scroller.scrollLeft <= 1;
        if (next) {
          const max = scroller.scrollWidth - scroller.clientWidth - 1;
          next.disabled = fitNow || scroller.scrollLeft >= max;
        }
      };

      refresh();
      addEventListener('resize', refresh);
      addEventListener('load', refresh);
      scroller.addEventListener('scroll', refresh, { passive: true });

      if (prev) prev.addEventListener('click', () => scroller.scrollBy({ left: -scroller.clientWidth, behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => scroller.scrollBy({ left: scroller.clientWidth, behavior: 'smooth' }));
    };

    wraps.forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-size-quiz"] && !Shopify.designMode) return;
  try {
    
  class SizeQuiz extends HTMLElement {
    connectedCallback() {
      this.sizes = this.dataset.sizes.split(',');
      this.chest = this.dataset.chest.split(',');
      this.length = this.dataset.length.split(',');
      this.sleeve = this.dataset.sleeve.split(',');
      this.usual = null;
      this.fit = null;

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('.gt-quiz__opt');
        if (!btn) return;
        e.preventDefault();
        const group = btn.closest('[data-usual], [data-fit]');
        if (group.hasAttribute('data-usual')) this.usual = btn.dataset.value;
        else this.fit = btn.dataset.value;
        group.querySelectorAll('.gt-quiz__opt').forEach((b) =>
          b.setAttribute('aria-pressed', String(b === btn)));
        this.render();
      });
    }

    render() {
      if (!this.usual || !this.fit) return;
      const i = this.sizes.indexOf(this.usual);
      const atTop = i === this.sizes.length - 1;
      const up = this.fit === 'up' && !atTop;
      const j = up ? i + 1 : i;
      const size = this.sizes[j];

      let note;
      if (this.fit === 'up' && atTop) {
        // never imply a size exists that is not stocked
        note = `${size} is the largest size we make. It is already cut boxy and `
             + `cropped, so it will read oversized on most people.`;
      } else if (up) {
        note = `You normally wear ${this.usual}. For a roomier, longer fit we `
             + `suggest sizing up to ${size}.`;
      } else {
        note = `The hoodie runs true to size, so ${size} gives you the boxy, `
             + `cropped proportion it was cut for.`;
      }

      const out = this.querySelector('[data-result]');
      this.querySelector('[data-size]').textContent = size;
      this.querySelector('[data-note]').textContent = note;
      this.querySelector('[data-measure]').innerHTML =
        `<dt>Chest</dt><dd>${this.chest[j]}"</dd>` +
        `<dt>Body length</dt><dd>${this.length[j]}"</dd>` +
        `<dt>Sleeve</dt><dd>${this.sleeve[j]}"</dd>`;
      out.hidden = false;
    }
  }
  if (!customElements.get('size-quiz')) customElements.define('size-quiz', SizeQuiz);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-usecase-tabs"] && !Shopify.designMode) return;
  try {
    
  class GtTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.addEventListener('click', (e) => {
        const tab = e.target.closest('[role="tab"]');
        if (tab) this.select(this.tabs.indexOf(tab));
      });
      // Arrow-key navigation is what makes a tablist a tablist rather than a
      // row of buttons; without it the role is a lie to screen readers.
      this.addEventListener('keydown', (e) => {
        const i = this.tabs.indexOf(document.activeElement);
        if (i < 0) return;
        const last = this.tabs.length - 1;
        let next = null;
        if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
        else if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = last;
        if (next === null) return;
        e.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      });
    }

    select(index) {
      if (index < 0) return;
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        if (this.panels[i]) this.panels[i].hidden = !on;
      });
    }
  }
  if (!customElements.get('gt-tabs')) customElements.define('gt-tabs', GtTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-worn-worldwide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const setup = (wrap) => {
      const scroller = wrap.querySelector('.gt-ww__scroller');
      const rail = wrap.querySelector('.gt-ww__rail');
      if (!scroller || !rail) return;
      const prevBtn = wrap.querySelector('.gt-ww__arrow--prev');
      const nextBtn = wrap.querySelector('.gt-ww__arrow--next');

      const fits = () => scroller.scrollWidth <= scroller.clientWidth + 2;

      const step = () => {
        const item = rail.querySelector('.gt-ww__item');
        const gap = parseFloat(getComputedStyle(rail).columnGap || '0') || 0;
        return item ? item.getBoundingClientRect().width + gap : scroller.clientWidth * 0.8;
      };

      const updateState = () => {
        const fitNow = fits();
        wrap.toggleAttribute('data-fits', fitNow);
        if (prevBtn) prevBtn.disabled = fitNow || scroller.scrollLeft <= 1;
        if (nextBtn) {
          const max = scroller.scrollWidth - scroller.clientWidth - 1;
          nextBtn.disabled = fitNow || scroller.scrollLeft >= max;
        }
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          scroller.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          scroller.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      // Plain mouse wheels only report vertical delta — redirect it here so
      // desktop users without a trackpad can still scroll the rail.
      scroller.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          scroller.scrollLeft += e.deltaY;
          e.preventDefault();
        }
      }, { passive: false });

      // Click-and-drag for desktop mouse users; suppresses the resulting
      // click on the <a> so a drag never fires as an accidental navigation.
      let dragging = false;
      let dragged = false;
      let startX = 0;
      let startScroll = 0;

      scroller.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return;
        dragging = true;
        dragged = false;
        startX = e.clientX;
        startScroll = scroller.scrollLeft;
        scroller.setPointerCapture(e.pointerId);
      });
      scroller.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 3) dragged = true;
        scroller.scrollLeft = startScroll - dx;
      });
      const endDrag = () => { dragging = false; };
      scroller.addEventListener('pointerup', endDrag);
      scroller.addEventListener('pointercancel', endDrag);
      scroller.addEventListener('click', (e) => {
        if (dragged) {
          e.preventDefault();
          dragged = false;
        }
      }, true);

      scroller.addEventListener('scroll', updateState, { passive: true });
      addEventListener('resize', updateState);
      updateState();
    };

    const init = () => document.querySelectorAll('.gt-ww__nav-wrap').forEach(setup);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // px/second = "scroll speed" setting x 8, so the default 5 reads as a calm 40px/s
    const RATE = 8;

    const build = (root) => {
      if (root.dataset.gtMarqueeReady) return;
      const track = root.querySelector('[data-gt-marquee-track]');
      if (!track) return;
      const originals = Array.from(track.children);
      if (!originals.length) return;
      root.dataset.gtMarqueeReady = '1';

      // every original is readable; only the clones are hidden from AT
      originals.forEach((n) => n.setAttribute('aria-hidden', 'false'));

      const oneSet = () => originals.reduce((s, n) => s + n.getBoundingClientRect().width, 0);

      let one = oneSet();
      if (!one) return;

      // repeat the set until the row is at least twice the visible width, so the
      // loop point is always off-screen
      const target = Math.max(root.clientWidth * 2, one * 2);
      let guard = 0;
      while (track.scrollWidth < target && guard++ < 20) {
        originals.forEach((n) => {
          const c = n.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('ref');
          c.removeAttribute('id');
          track.appendChild(c);
        });
      }

      const apply = () => {
        const w = oneSet();
        if (!w) return;
        const rate = (Number(root.dataset.gtMarqueeSpeed) || 5) * RATE;
        track.style.setProperty('--gt-marquee-distance', w + 'px');
        track.style.setProperty('--gt-marquee-duration', (w / rate).toFixed(2) + 's');
      };
      apply();

      let t;
      addEventListener('resize', () => { clearTimeout(t); t = setTimeout(apply, 150); }, { passive: true });
    };

    const boot = () => document.querySelectorAll('[data-gt-marquee]').forEach(build);
    boot();
    // the theme editor re-renders the section without a full page load
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
